export default __webpack_public_path__ + "static/media/commercial-.886d881a.svg";